const status = {
  OK: "ok",
  NOK: "nok",
};

export default status;
